// legacy/workaround: Albaster renders its slots as clock ranges, but the BE
// availability endpoint expects these named windows.
const toAlbasterServicePreference = (slot: string): string => {
  const [day] = slot.split(' ');

  if (slot.includes('7:30 - 11:30')) {
    return `${day}:7am-11am`;
  }

  if (slot.includes('11:30 - 3:30')) {
    return `${day}:11am-3pm`;
  }

  return `${day}:all day`;
};

const toServicePreferences = (
  selection: string,
  theme: string | null
): string[] => {
  const selectedSlots: string[] = selection.split(',');

  if (theme === 'Albaster') {
    return selectedSlots.map((slot: string) =>
      toAlbasterServicePreference(slot)
    );
  }

  return selectedSlots.map((slot: string) => {
    const [day, window] = slot.split(' ');

    return `${day}:${window}`;
  });
};

const buildCalendlyEmbedUrl = (
  schedulingUrl: string,
  propertyManager: any
): string => {
  if (!schedulingUrl) {
    return '';
  }

  const embedParams: URLSearchParams = new URLSearchParams({
    embed_domain: window.location.hostname,
    embed_type: 'Inline',
    name: propertyManager?.name ?? '',
    email: propertyManager?.email ?? '',
  });

  return `${schedulingUrl}?${embedParams.toString()}`;
};

export {
  toAlbasterServicePreference,
  toServicePreferences,
  buildCalendlyEmbedUrl,
};